var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm"},[_c('div',{staticClass:"icon"},[_c('i',{class:_vm.icon + ' fa-3x'})]),_c('div',[_c('h2',[_vm._v(_vm._s(_vm.name))]),_c('p',[_vm._v(_vm._s(_vm.text))])])])}
var staticRenderFns = []

export { render, staticRenderFns }